// LinkedIn Insight Tag (partner id 9443090). Same policy as posthog.js:
// only real production traffic should reach LinkedIn, so local dev hosts
// are skipped entirely. Loaded as a module, so there is no <noscript>
// fallback pixel — acceptable, since ad measurement needs JS anyway.
//
// Marketing is opt in: the tag is only injected after the visitor accepts the
// marketing category in the cookie banner (scripts/CookieConsent.jsx).

import { hasConsent, onConsentChange } from '../scripts/consent.js';
import { isInternalDevice } from './posthog.js';

const PARTNER_ID = '9443090';

function isLocalhost() {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname;
  return (
    h === 'localhost' ||
    h === '127.0.0.1' ||
    h === '0.0.0.0' ||
    h === '[::1]' ||
    h === '::1' ||
    h.endsWith('.local')
  );
}

let loaded = false;

function loadInsightTag() {
  if (loaded || isLocalhost() || isInternalDevice() || !hasConsent('marketing')) return;
  if (!['scopeworth.app', 'www.scopeworth.app', 'getscopeworth.com', 'www.getscopeworth.com'].includes(window.location.hostname)) return;
  loaded = true;

  window._linkedin_partner_id = PARTNER_ID;
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  window._linkedin_data_partner_ids.push(PARTNER_ID);

  if (!window.lintrk) {
    window.lintrk = function (a, b) { window.lintrk.q.push([a, b]); };
    window.lintrk.q = [];
  }

  const s = document.createElement('script');
  s.type = 'text/javascript';
  s.async = true;
  s.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
  document.head.appendChild(s);
}

if (hasConsent('marketing')) loadInsightTag();

// Accepting later loads the tag without a reload. Withdrawal cannot unload an
// already running tag, so the banner reloads the page instead.
onConsentChange((consent) => {
  if (consent.marketing) loadInsightTag();
});
